class Drawer extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
        this.querySelector('[data-overlay]').addEventListener('click', this.close.bind(this));
        this.querySelector('[data-drawer-close]').addEventListener('click', this.close.bind(this))
        this.isDesktop = window.innerWidth > 1024;
    }

    setIconAccessibility(detailsLink) {
        this.querySelector('[data-details]').classList.add(this.isDesktop ? 'desktop-drawer' : 'mobile-drawer');

        detailsLink.setAttribute('role', 'button');
        detailsLink.setAttribute('aria-haspopup', 'dialog');
        detailsLink.addEventListener('click', (event) => {
            event.preventDefault();
            this.open(detailsLink);
        });
        this.addEventListener('keydown', (event) => {
            if (event.code.toUpperCase() === 'SPACE') {
                event.preventDefault();
                this.open(this);
            }
        });
    }

    open(triggeredBy) {
        if (triggeredBy) this.setActiveElement(triggeredBy);
        // here the animation doesn't seem to always get triggered. A timeout seem to help
        setTimeout(() => {
            this.classList.add('animate');
            this.setAttribute('open', '');
        });
        document.body.classList.add('overflow-hidden');
    }

    close() {
        this.removeAttribute('open');
        document.body.classList.remove('overflow-hidden');
    }

    setActiveElement(element) {
        this.activeElement = element;
    }
}

